export default __webpack_public_path__ + "static/media/Billed.cf050e80.svg";